module.exports = __webpack_public_path__ + "img/rules_3.7631ae1d.png";